import request from '@/utils/request'
import qs from 'qs'
import website from "@/utils/website";

// export function login(data) {
//   return request({
//     url: '/vue-admin-template/user/login',
//     method: 'post',
//     data
//   })
// }

const scope = 'server'
export const loginByUsername = (username, password, code, randomStr) => {
  const grant_type = 'password'
  let dataObj = qs.stringify({ 'username': username, 'password': password })

  let basicAuth = 'Basic ' + window.btoa(website.formLoginClient)

  return request({
    url: '/auth/oauth2/token',
    headers: {
      isLogin: true,
      Authorization: basicAuth
    },
    method: 'post',
    params: { randomStr, code, grant_type, scope },
    data: dataObj
  })
}

export const getStatus = () => {
  return request({
    url: '/shop/shop/status',
    method: 'get'
  })
}

export function getMenu(id) {
  return request({
    url: '/admin/menu',
    params: { parentId: id },
    method: 'get'
  })
}

export function getInfo(userId) {
  return request({
    // url: `member/manage/${userId}`,
    // url: 'admin/user/info',
    url: '/member/info/detailed',
    method: 'get',
    params: { }
  })
}

// export function getInfoa(token) {
//   return request({
//     url: '/vue-admin-template/user/info',
//     method: 'get',
//     params: { token }
//   })
// }

export function logout() {
  return request({
    url: '/vue-admin-template/user/logout',
    method: 'post'
  })
}

// //用户详情查询
// export function getUserInfo(data) {
//   return request({
//     url: "/admin/user/"+data,
//     method: "get",
//   })
// }


export function imgUpload(data) {
  return request({
    url: `/shop/shopcertify/upload`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: "post",
    data,
  });
}

// 用户详情查询
export function getUserInfo(data) {
  return request({
    url: "/admin/user/" + data,
    method: "get",
  })
}

// 修改密码
export function editPassword(data) {
  return request({
    // url: "/admin/user/modify/password",
    url: '/member/manage/modify/password',
    method: "put",
    data,
  })
}

// 修改密码
export function getRolesList(data) {
  return request({
    url: "/admin/role/shop/list",
    // url: '/member/manage/modify/password',
    method: "get",
    params: data,
  })
}

// 发送短信验证码
export function sendCode(data) {
  return request({
    url: "/member/sms/send/code",
    method: "post",
    data,
  })
}
// 会员注册
export function register(data) {
  return request({
    url: "/member/register",
    method: "post",
    data,
  })
}
// 确认修改密码
export function forgetPassword(data) {
  return request({
    url: "/member/forgetPassword/confirm-modify",
    method: "put",
    data,
  })
}
// 绑定商户
export function merchantBind(data) {
  return request({
    url: `/shop/merchant/bind`,
    method: "post",
    data,
  });
}
// 根据商户编码获取手机号码并发送手机号码
export function findPhoneByMerchant(data) {
  return request({
    url: `/shop/merchant/findPhoneByMerchant`,
    method: "get",
    params: data,
  });
}